import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-wrapper" }
const _hoisted_2 = {
  class: "small striped toggle no-underline mt-30",
  id: "table-contract-info"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", { class: "large large_padding" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-5" }),
    /*#__PURE__*/_createElementVNode("th", null, "Member Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Employer"),
    /*#__PURE__*/_createElementVNode("th", null, "Production"),
    /*#__PURE__*/_createElementVNode("th", null, "Work Period"),
    /*#__PURE__*/_createElementVNode("th", { class: "col-md-2" }, "Fund"),
    /*#__PURE__*/_createElementVNode("th", null, "Amt. Paid $ ")
  ])
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  colspan: "7",
  class: "text-center"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "large" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "col-md-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("tr", null, null, -1)
const _hoisted_12 = { class: "showDetails grey-border" }
const _hoisted_13 = { colspan: "10" }
const _hoisted_14 = { class: "small striped toggle no-underline mt-10" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", { class: "large large_padding" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light-green" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Work Period"),
    /*#__PURE__*/_createElementVNode("th", null, "Receipt Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Work Units"),
    /*#__PURE__*/_createElementVNode("th", null, "Fund"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount Due $"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount Paid $")
  ])
], -1)
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "iatse-icon-clock fs-base position-relative plan-modal icon-tooltip icon-tooltip-info icon-tooltip_units fs-lg" }
const _hoisted_18 = { class: "tooltip-text" }
const _hoisted_19 = { class: "w-100 d-flex gap-20 mb-5" }
const _hoisted_20 = { class: "text-danger" }
const _hoisted_21 = { class: "large" }
const _hoisted_22 = {
  class: "col-md-3",
  colspan: "6"
}
const _hoisted_23 = { class: "col-md-2 d-flex gap-20 mb-5 bg-fourth text-white pdl-10 pdr-10 pdt-10 pdb-10 rounded" }
const _hoisted_24 = {
  key: 1,
  class: "w-100"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "text-center w-100 fs-sm" }, " Loading Totals...", -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "fw-bold p-4 col-md-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "divider divider_vertical divider_vertical_mobile" }, null, -1)
const _hoisted_29 = { class: "totals-grid" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = {
  key: 1,
  class: "mt-5 fs-sm sm-gap-0 bordered-card bg-light-green w-100 flex-column flex-md-row p-0"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold p-4 col-md-2" }, "Grand Total", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "divider divider_vertical divider_vertical_mobile" }, null, -1)
const _hoisted_35 = { class: "totals-grid" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      (!_ctx.contributionsStore.contributions)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.loading ? 'Loading...' : 'No records found'), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.contributionsStore.contributions)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedContributions, ({year, yearWorkHistory}) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: year }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearWorkHistory, (entry, member) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: member }, [
                    _createElementVNode("tr", _hoisted_7, [
                      _createElementVNode("td", {
                        onClick: ($event: any) => (_ctx.toggleDetails(member)),
                        class: "plan-modal w-5"
                      }, _toDisplayString(entry.showDetails ? ' - ' : ' + '), 9, _hoisted_8),
                      _createElementVNode("td", null, _toDisplayString(entry?.MemberName), 1),
                      _createElementVNode("td", null, _toDisplayString(entry?.Employer), 1),
                      _createElementVNode("td", null, _toDisplayString(entry?.Production), 1),
                      _createElementVNode("td", {
                        innerHTML: entry?.WorkPeriod
                      }, null, 8, _hoisted_9),
                      _createElementVNode("td", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry?.Plan, (amountPaid, fund) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "w-100 d-flex flex-column gap-10",
                            key: fund
                          }, [
                            _createElementVNode("span", null, _toDisplayString(fund), 1)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("td", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry?.Plan, (amountPaid, fund) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "w-100 d-flex flex-column gap-10",
                            key: fund
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.formatNumber(amountPaid)), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _hoisted_11,
                    _withDirectives(_createElementVNode("tr", _hoisted_12, [
                      _createElementVNode("td", _hoisted_13, [
                        _createElementVNode("table", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(entry?.Items), ([receiptDate, item]) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: receiptDate,
                                class: "large"
                              }, [
                                _createElementVNode("td", {
                                  innerHTML: item?.WorkPeriod
                                }, null, 8, _hoisted_16),
                                _createElementVNode("td", null, _toDisplayString(item?.ReceiptDate), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("i", _hoisted_17, [
                                    _createElementVNode("span", _hoisted_18, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.WorkUnits, (value, unit) => {
                                        return (_openBlock(), _createElementBlock("p", { key: unit }, _toDisplayString(unit) + " - " + _toDisplayString(value), 1))
                                      }), 128))
                                    ])
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.Plan, (amountPaid, fund) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "w-100 d-flex flex-column gap-10",
                                      key: fund
                                    }, [
                                      _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("span", null, _toDisplayString(fund), 1)
                                      ])
                                    ]))
                                  }), 128))
                                ]),
                                _createElementVNode("td", _hoisted_20, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.Plan, (amountPaid, fund) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "w-100 d-flex flex-column gap-10",
                                      key: fund
                                    }, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.formatNumber(amountPaid)), 1)
                                    ]))
                                  }), 128))
                                ]),
                                _createElementVNode("td", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.Plan, (amountPaid, fund) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "w-100 d-flex flex-column gap-10",
                                      key: fund
                                    }, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.formatNumber(amountPaid)), 1)
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            }), 128)),
                            _createElementVNode("tr", _hoisted_21, [
                              _createElementVNode("td", _hoisted_22, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry?.Plan, (amountPaid, fund) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "w-100 d-flex align-items-end flex-column gap-10",
                                    key: fund
                                  }, [
                                    _createElementVNode("div", _hoisted_23, _toDisplayString(fund) + " : " + _toDisplayString(_ctx.formatNumber(amountPaid)), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ], 512), [
                      [_vShow, entry?.showDetails]
                    ])
                  ], 64))
                }), 128))
              ], 64))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.loading && _ctx.contributionsStore.contributions && _ctx.contributionsStore?.paginator)
      ? (_openBlock(), _createBlock(_component_PaginationComponent, {
          key: 0,
          paginator: _ctx.contributionsStore?.paginator,
          onFetchData: _ctx.fetchPaginationData
        }, null, 8, ["paginator", "onFetchData"]))
      : _createCommentVNode("", true),
    (_ctx.loadingTotals)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (!_ctx.loadingTotals && _ctx.contributionsStore.totals?.Years)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.contributionsStore.totals.Years, (totals, year) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: year,
                  class: "mt-5 sm-gap-0 fs-sm bordered-card bg-light-green flex-column flex-md-row w-100 p-0"
                }, [
                  _createElementVNode("span", _hoisted_27, "Total for " + _toDisplayString(year), 1),
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totals, (total, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "grid-item flex-md-row flex-column"
                      }, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(total.FundName), 1),
                        _createElementVNode("span", _hoisted_31, "$ " + _toDisplayString(_ctx.formatNumber(total.FundAmount)), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            : _createCommentVNode("", true),
          (!_ctx.loadingTotals && _ctx.contributionsStore.totals?.GrandTotals)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _hoisted_33,
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contributionsStore.totals?.GrandTotals, (total, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "grid-item flex-md-row flex-column"
                    }, [
                      _createElementVNode("span", _hoisted_36, _toDisplayString(total.FundName), 1),
                      _createElementVNode("span", _hoisted_37, "$ " + _toDisplayString(_ctx.formatNumber(total.Value)), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}